import { render, staticRenderFns } from "./SpeakerView.vue?vue&type=template&id=2e85acf2"
import script from "./SpeakerView.vue?vue&type=script&lang=js"
export * from "./SpeakerView.vue?vue&type=script&lang=js"
import style0 from "./SpeakerView.vue?vue&type=style&index=0&id=2e85acf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports